import { useRole } from "Hooks/Endpoints";
import { APIRoleProps } from "Providers/types";
import React from "react";
import { Card } from "semantic-ui-react";
import RoleCreate from "./RoleCreate";
import RoleDetails from "./RoleDetails";
import RoleTable from "./RoleTable";

const RoleView = () => {
  const { createRole, role }: APIRoleProps = useRole();

  return (
    <Card.Content>
      {!role && !createRole && <RoleTable />}
      {!role && createRole && <RoleCreate />}
      {role && <RoleDetails />}
    </Card.Content>
  );
};

export default RoleView;
